/**
 * Returns a comma separated list of participants (excluding self)
 */
export default function getParticipantsListExcludingSelf(
  participantsOrMessages: {
    user?: { givenName: string; id: string };
    host?: { name: string; id: string };
  }[],
  selfParticipantID: string,
): string {
  const participantsExcludingSelf = participantsOrMessages.filter(
    (participant) => {
      // Exclude self
      if (
        participant.user?.id === selfParticipantID ||
        participant.host?.id === selfParticipantID
      ) {
        return false;
      }

      // Exclude empty
      if (!participant.user?.id && !participant.host?.id) {
        return false;
      }

      return true;
    },
  );

  return participantsExcludingSelf
    .map((i) => i.user?.givenName || i.host?.name)
    .join(', ');
}
